import { render, staticRenderFns } from "./CustomerSummaryStandardLink.vue?vue&type=template&id=33a8cd8d"
import script from "./CustomerSummaryStandardLink.vue?vue&type=script&lang=ts"
export * from "./CustomerSummaryStandardLink.vue?vue&type=script&lang=ts"
import style0 from "./CustomerSummaryStandardLink.vue?vue&type=style&index=0&id=33a8cd8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports